module.exports = __webpack_public_path__ + "assets/webgl/360_vignes_L0.jpg.6b9ccf58.webp";